import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { api } from "../../api/api";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IStoreState } from "../initialStoreState";
import {
	saveLoaderCompleted,
	saveLoaderProgress,
	showMessage,
} from "../messages/messagesActions";
import { IFeeTransition, IStudent } from "./student.types";
import { ILead } from "../leads/leads.types";

//******************************STUDENT FETCHING START *********************************** */

export const FETCH_CUSTOMER_FULL_DETAILS_PROGRESS =
	"FETCH_CUSTOMER_FULL_DETAILS_PROGRESS";
export const ADD_CUSTOMER_FULL_DETAILS_SUCCESS =
	"ADD_CUSTOMER_FULL_DETAILS_SUCCESS";
export const FETCH_CUSTOMER_FULL_DETAILS_FAILED =
	"FETCH_CUSTOMER_FULL_DETAILS_FAILED";

export const fetchStudentListProgress = () =>
	action(FETCH_CUSTOMER_FULL_DETAILS_PROGRESS);
export const fetchStudentListSuccess = (
	data: IStudent[],
	totalRecords: number
) =>
	action(ADD_CUSTOMER_FULL_DETAILS_SUCCESS, {
		data,
		totalRecords,
	});
export const fetchStudentListFailed = () =>
	action(FETCH_CUSTOMER_FULL_DETAILS_FAILED);

export const fetchStudentsListAsync =
	(
		pageNumber: number,
		rowsInPerPage: number,
		limit: number,
		status: string,
		date: IDataTableV2DateState["dates"],
		searchValue: IDatatableV2AdvancedSearchFilter,
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(fetchStudentListProgress());
				dispatch(saveLoaderProgress());

				let url = "";

				// if(status !== "-1") {
				//   url += `&status=${status}`;}

				if (searchValue.length > 0) {
					url += `&advanceFilter=${JSON.stringify(searchValue)}`;
				}
				if (status !== "-1") {
					url += `&status=${status}`;
				}

				const finalUrl =
					`/customer/get-customer?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
					url;
				// &from_date=${date.fromDate}&to_date=${date.toDate}

				// Make the API call
				const response = await api.get(finalUrl);
				// Check if the response is valid
				if (response.status === 200 && response.data) {
					const data: IStudent[] = response.data.data;

					const totalRecords =
						response.data.totalRecords ??
						response.data.total ??
						response.data.totalCount ??
						response.data.count ??
						(Array.isArray(data) ? data.length : 0);

					console.log(data, "data////////////");

					dispatch(fetchStudentListSuccess(data, totalRecords));
				}
			} catch (err: any) {
				dispatch(fetchStudentListFailed());
				dispatch(
					showMessage({
						type: "error",
						message: err.response?.data?.message,
						displayAs: "snackbar",
					})
				);
			} finally {
				dispatch(saveLoaderCompleted());
			}
		};

//******************************STUDENT FETCHING END *********************************** */

//***********STUDENT SINGLE DATA FETCH START ******************************************* */
export const FETCH_STUDENT_PROGRESS = "FETCH_STUDENT_PROGRESS";
export const FETCH_STUDENT_SUCCESS = "FETCH_STUDENT_SUCCESS";
export const FETCH_STUDENT_FAILED = "FETCH_STUDENT_FAILED";

export const fetchStudentProgress = () => action(FETCH_STUDENT_PROGRESS);
export const fetchStudentSuccess = (Student: IStudent) =>
	action(FETCH_STUDENT_SUCCESS, { Student });
export const fetchStudentFailed = (errorMessage: string) =>
	action(FETCH_STUDENT_FAILED, { errorMessage });

export const fetchStudentAsync =
	(student_uuid: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(fetchStudentProgress());
				dispatch(saveLoaderProgress());
				let url = `/customer/get-customer?customer_fact_uuid=${student_uuid}`;
				const res = await api.get(url);
				const data = res.data.data;
				if (data.length > 0) {
					dispatch(fetchStudentSuccess(data[0]));
				} else {
					dispatch(
						fetchStudentFailed(
							"Unfortunately, there are no records available at the moment."
						)
					);
				}
			} catch (err: any) {
				dispatch(fetchStudentFailed("Something went to be wrong!"));
				dispatch(
					showMessage({
						type: "error",
						message: err.response?.data?.message,
						displayAs: "snackbar",
					})
				);
			} finally {
				dispatch(saveLoaderCompleted());
			}
		};

//******************************STUDENT SINGLE DATA FETCH END *********************************** */

//******************************STUDENT UPSERT START *********************************** */
export const upsertStudentAysnc =
	(
		existingLead: IStudent,
		onCallBack: (isSuccess?: boolean, data?: IStudent) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			dispatch(saveLoaderProgress());
			try {
				const {
					customer_personal_information_unique_id,
					customer_personal_information_id,
					created_by_uuid,
					created_by_name,
					create_ts,
					insert_ts,
					modified_by_name,
					modified_by_uuid,

					...rest
				} = existingLead;
				console.log(rest);

				const res = await api.post("/customer/upsert-customer", rest);
				dispatch(
					showMessage({
						type: "success",
						message: "Customer is saved succesfully!",
						displayAs: "snackbar",
					})
				);
				const data = res.data.data;
				onCallBack(true, data);
			} catch (err: any) {
				onCallBack(false);
				dispatch(
					showMessage({
						type: "error",
						message: err.response?.data?.message,
						displayAs: "snackbar",
					})
				);
			} finally {
				dispatch(saveLoaderCompleted());
			}
		};

//********************************STUDENT UPSERT END *********************************** */

//********************************FEE TRANSITION START *********************************** */

export const FETCH_FEE_TRANINSTION_LIST_PROGRESS =
	"FETCH_FEE_TRANINSTION_LIST_PROGRESS";
export const FETCH_FEE_TRANINSTION_LIST_SUCCESS =
	"ADD_FEE_TRANINSTION_LIST_SUCCESS";
export const FETCH_FEE_TRANINSTION_LIST_FAILED =
	"FETCH_FEE_TRANINSTION_LIST_FAILED";

export const fetchFeeTransitionListProgress = () =>
	action(FETCH_FEE_TRANINSTION_LIST_PROGRESS);
export const fetchFeeTransitionListSuccess = (
	data: IFeeTransition[],
	totalRecords: number
) =>
	action(FETCH_FEE_TRANINSTION_LIST_SUCCESS, {
		data,
		totalRecords,
	});
export const fetchFeeTransitionListFailed = () =>
	action(FETCH_FEE_TRANINSTION_LIST_FAILED);

export const fetchhFeeTransitionListAsync =
	(
		pageNumber: number,
		rowsInPerPage: number,

		studentFactId: string | null,
		date?: IDataTableV2DateState["dates"],
		status?: string,
		searchValue?: IDatatableV2AdvancedSearchFilter,
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(fetchFeeTransitionListProgress());
				// dispatch(saveLoaderProgress());

				let url = "";

				// if(status !== "-1") {
				//   url += `&status=${status}`;}

				// if(searchValue.length > 0) {
				//   url += `}&advanceFilter=${JSON.stringify(searchValue)}`
				// }

				if (studentFactId !== null) {
					url += `&customer_fact_uuid=${studentFactId}`;
				}

				const finalUrl =
					`/customer/get-fee-transaction?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}` +
					url;
				// &from_date=${date.fromDate}&to_date=${date.toDate}

				// Make the API call
				const response = await api.get(finalUrl);
				// Check if the response is valid
				if (response.status === 200 && response.data) {
					const data: IFeeTransition[] = response.data.data;

					const totalRecords = response.data.totalRecords;

					console.log(data, "data////////////");

					dispatch(fetchFeeTransitionListSuccess(data, totalRecords));
				}
			} catch (err: any) {
				dispatch(fetchFeeTransitionListFailed());
				dispatch(
					showMessage({
						type: "error",
						message: err.response?.data?.message,
						displayAs: "snackbar",
					})
				);
			}
			// finally{
			//   dispatch(saveLoaderCompleted());
			// }
		};

//********************************FEE TRANSITION END *********************************** */

export const CLEAR_STUDENT_STATE = "CLEAR_STUDENT_STATE";
export const CLEAR_STUDENT = "CLEAR_STUDENT";

export const clearStudentsState = () => action(CLEAR_STUDENT_STATE);
export const clearStudent = () => action(CLEAR_STUDENT);

//******************************CONVERT BOOKED LEAD TO CUSTOMER START *********************************** */

export const convertBookedLeadToCustomerAsync =
	(
		lead: ILead,
		onCallBack: (isSuccess?: boolean, data?: IStudent) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			dispatch(saveLoaderProgress());
			try {
				// Map lead data to customer data structure
				const customerData: Partial<IStudent> = {
					customer_name: lead.name,
					email: lead.email,
					contact_number: lead.contact_number,
					representative_name: lead.representative_name || lead.name,
					representative_email: lead.representative_email || lead.email,
					representative_contact: lead.representative_contact || lead.contact_number,
					event_type: lead.event_type,
					remarks: lead.remarks || "",
					status: "ACTIVE" as const,
					city: lead.city || "",
					state: lead.state || "",
					// Map additional fields as needed
					created_by_uuid: lead.created_by_uuid,
					created_by_name: lead.created_by_name,
					modified_by_uuid: lead.modified_by_uuid,
					modified_by_name: lead.modified_by_name,
					create_ts: new Date().toISOString(),
					insert_ts: new Date().toISOString(),
				};

				const res = await api.post("/customer/upsert-customer", customerData);
				dispatch(
					showMessage({
						type: "success",
						message: "Lead successfully converted to customer!",
						displayAs: "snackbar",
					})
				);
				const data = res.data.data;
				onCallBack(true, data);
			} catch (err: any) {
				onCallBack(false);
				dispatch(
					showMessage({
						type: "error",
						message: err.response?.data?.message || "Failed to convert lead to customer",
						displayAs: "snackbar",
					})
				);
			} finally {
				dispatch(saveLoaderCompleted());
			}
		};

//******************************FETCH BOOKED LEADS AS CUSTOMERS START *********************************** */

export const fetchBookedLeadsAsCustomersAsync =
	(
		pageNumber: number,
		rowsInPerPage: number,
		limit: number,
		contactNumber: string,
		date: IDataTableV2DateState["dates"],
		searchValue: IDatatableV2AdvancedSearchFilter,
		customerName?: string,
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(fetchStudentListProgress());
				dispatch(saveLoaderProgress());

				const advanceFilter = Array.isArray(searchValue) ? [...searchValue] : [];

				if (customerName && customerName.trim() !== "") {
					advanceFilter.push({
						column: ["customer_name"],
						logicalOperator: "AND",
						operator: "CONTAINS",
						value: customerName.trim(),
					});
				}

				let url = "";

				if (advanceFilter.length > 0) {
					url += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
				}

				if (contactNumber && contactNumber.trim() !== "") {
					url += `&contact_number=${encodeURIComponent(contactNumber.trim())}`;
				}

				if (customerName && customerName.trim() !== "") {
					url += `&customer_name=${encodeURIComponent(customerName.trim())}`;
				}

				const finalUrl =
					`/customer/get-customer?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
					url;

				// Make the API call
				const response = await api.get(finalUrl);
				const data = response.data.data;
				const totalRecords =
					response.data.totalRecords ??
					response.data.total ??
					response.data.totalCount ??
					response.data.count ??
					(Array.isArray(data) ? data.length : 0);
				dispatch(fetchStudentListSuccess(data, totalRecords));
			} catch (err: any) {
				dispatch(fetchStudentListFailed());
				dispatch(
					showMessage({
						type: "error",
						message: err.response?.data?.message,
						displayAs: "snackbar",
					})
				);
			} finally {
				dispatch(saveLoaderCompleted());
			}
		};

//******************************FETCH BOOKED LEADS AS CUSTOMERS END *********************************** */
